export const snapchatEvent = (eventName, params) => {
    if (typeof window.snaptr !== 'undefined') {
      window.snaptr('track', eventName, params);
    } else {
      console.warn('Snapchat Pixel snaptr function is not available.');
    }
  };
  